import * as Preact from "preact"

import App from "@frog/source/models/App.js"

import Dice from "@frog/source/data/games/dice/views/Dice.jsx"
import DiceCube from "@frog/source/data/games/dice/views/DiceCube.jsx"

import CarryOn from "@frog/source/data/games/dice/scripts/CarryOn.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

import "./Modals.less"

export default function LearnToRightClickModal() {
    return PlotSteps.CustomViewModal({
        "view": (stage) => {
            if(App?.game == undefined) return
            const unit = stage.units["dog"]
            return (
                <div class="LearnToRightClickModal">
                    <div class="Fill"/>
                    <div class="Content">
                        <div class="Header">
                            <div class="BigText">Welcome!!!</div>
                            <div class="SmallText">Right-click on an item<br/>to learn more about it!!</div>
                        </div>
                        <section class="UnitsSection">
                            <Dice item={unit.diceFaces[0]} unit={unit} stage={stage} animation="roll"/>
                        </section>
                        <div class="Footer" isVisible={window.hasRightClicked == true}>
                            <div class="SmallText" isHoverable={true} onClick={(event) => CarryOn(stage)}>[Continue]</div>
                        </div>
                    </div>
                </div>
            )
        }
    })
}
